module.exports = __webpack_public_path__ + "img/r-208.19b2d0fe.jpg";